import { SYMPTOM_CHECKLIST } from "@ferrivia/api-contract";

export interface SymptomChange {
  added: string[];
  dropped: string[];
}

const ORDER: ReadonlyMap<string, number> = new Map(SYMPTOM_CHECKLIST.map((entry, index) => [entry.id, index]));

export function byChecklistOrder(ids: readonly string[]): string[] {
  const rank = (id: string) => ORDER.get(id) ?? Number.MAX_SAFE_INTEGER;
  return [...ids].sort((a, b) => rank(a) - rank(b));
}

export function symptomChange(latest: readonly string[], baseline: readonly string[]): SymptomChange {
  const now = new Set(latest);
  const before = new Set(baseline);
  return {
    added: byChecklistOrder(latest.filter((id) => !before.has(id))),
    dropped: byChecklistOrder(baseline.filter((id) => !now.has(id))),
  };
}
